"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var js_beautify = require("js-beautify/js");
var JavascriptCodePipe = (function () {
    function JavascriptCodePipe() {
    }
    JavascriptCodePipe.prototype.transform = function (value) {
        value = value.toString();
        var ret = value;
        return js_beautify(value);
    };
    return JavascriptCodePipe;
}());
JavascriptCodePipe = __decorate([
    core_1.Pipe({ name: 'jsCode' }),
    __metadata("design:paramtypes", [])
], JavascriptCodePipe);
exports.JavascriptCodePipe = JavascriptCodePipe;
//# sourceMappingURL=javascript-code.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/infinite-list/~/@ngui/utils/dist/pipes/javascript-code.pipe.js
// module id = 224
// module chunks = 4